import { call, put, takeLatest } from "redux-saga/effects";

import { IBaseRespone } from "../../../../model/respone/IBaseRespone";
import { rootActions } from "../../../actions/rootActions";
import { ISMT_ChuDe_DeThiIn } from "../../../../model/respone/de-thi/ISMT_ChuDe_DeThiIn";
import {
  eChuDeThiInActionIds,
  IChuDeThiInActionTypes,
} from "../../../action-types/de-thi/de-thi-in/IChuDeThiInActions";
import { chuDeThiInApi } from "../../../../api/de-thi/de-thi-in/chuDeThiApi";

export function* chuDeThiInSaga(): any {
  yield takeLatest(eChuDeThiInActionIds.LOAD_START, loadWorker);
  yield takeLatest(eChuDeThiInActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eChuDeThiInActionIds.SAVE_START, saveWorker);
  yield takeLatest(
    eChuDeThiInActionIds.DELETE_MULTIPLE_START,
    deleteMultipleWorker
  );
}

function* loadWorker(action: IChuDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    chuDeThiInApi.SelectByIdNhom,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.chuDeThiIn.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThiIn.chuDeThiIn.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IChuDeThiInActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_ChuDe_DeThiIn;
  if (payload.id > 0) {
    res = yield call(chuDeThiInApi.Update, payload);
  } else {
    res = yield call(chuDeThiInApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.deThi.deThiIn.chuDeThiIn.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.deThi.deThiIn.chuDeThiIn.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IChuDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    chuDeThiInApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.chuDeThiIn.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThiIn.chuDeThiIn.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
function* deleteMultipleWorker(action: IChuDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    chuDeThiInApi.DeleteMultiple,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(
      rootActions.deThi.deThiIn.chuDeThiIn.DELETE_MULTIPLE_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.deThi.deThiIn.chuDeThiIn.DELETE_MULTIPLE_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
